/**
 * @generated SignedSource<<4dc7cbda16909893d1c0938246058f48>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type ChMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE" | "TEMPLATE";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
import { FragmentRefs } from "relay-runtime";
export type chMedicationFragmentInline$data = {
  readonly __typename: "ch_Medication";
  readonly createdAt: string;
  readonly createdBy: string;
  readonly endDate: any | null;
  readonly eveningDosage: number;
  readonly id: string;
  readonly internalNotes: string | null;
  readonly isPermanentPrescription: boolean;
  readonly morningDosage: number;
  readonly name: string;
  readonly nightDosage: number;
  readonly noonDosage: number;
  readonly numberOfPackages: number;
  readonly packageSize: string | null;
  readonly patientId: string;
  readonly pharmaCode: number | null;
  readonly productUrl: any | null;
  readonly refuseSubstitutes: boolean;
  readonly startDate: any | null;
  readonly templateCategory: string | null;
  readonly templateId: number | null;
  readonly type: ChMedicationType;
  readonly unit: MedicationUnit;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly usageInstructions: string | null;
  readonly " $fragmentType": "chMedicationFragmentInline";
};
export type chMedicationFragmentInline$key = {
  readonly " $data"?: chMedicationFragmentInline$data;
  readonly " $fragmentSpreads": FragmentRefs<"chMedicationFragmentInline">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "chMedicationFragmentInline"
};

(node as any).hash = "af875cf47874d4c14c5d6d4f6d98734a";

export default node;
